import { render } from "./order-details.vue?vue&type=template&id=2b1668fc&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"

import "./order-details.vue?vue&type=style&index=0&id=2b1668fc&scoped=true&lang=css"

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1668fc"]])

export default __exports__